import React from "react";
import { isAuthor } from "../../../utils";
import Avatar from "@mui/material/Avatar";
import { Card } from "@mui/material";
import UserChatSkeleton from "../../../components/Skeleton/UserChatSkeleton";
import { useChatState } from "../../../context/context";
import { chatTimeFormat } from "../../../components/Form";

const UserList = ({ chats, loading }) => {
  const { selectedChat, setSelectedChat } = useChatState();

  return (
    <>
      {loading ? (
        <UserChatSkeleton />
      ) : chats.filter((chat) => chat.lastMessage).length > 0 ? (
        chats.map(
          ({
            _id,
            roomId,
            name,
            sendername,
            userId,
            senderId,
            profile,
            senderimage,
            lastMessage,
            isOnline,
            updatedAt,
          }) => {
            return (
              <Card
                sx={{ maxWidth: 345 }}
                key={_id}
                className=" my-3 chatWrapper"
              >
                <li
                  className={`p-2 friend-drawer--onhover  ${
                    selectedChat?.receiverId === userId && "active"
                  }`}
                  key={_id}
                  role="button"
                  onClick={() =>
                    setSelectedChat(
                      isAuthor(userId)
                        ? {
                            roomId,
                            receiverImage: profile,
                            receiverId: userId,
                            receiverName: name,
                          }
                        : {
                            roomId,
                            receiverImage: senderimage,
                            receiverId: senderId,
                            receiverName: sendername,
                          }
                    )
                  }
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row">
                      <div>
                        {/* <StyledBadge
                            overlap="circular"
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            variant="dot"
                            color={isOnline ? "success" : "error"}
                          >
                          </StyledBadge> */}
                        <Avatar
                          alt={isAuthor(userId) ? name : sendername}
                          src={isAuthor(userId) ? profile : senderimage}
                        />
                      </div>
                      <div className="pt-1 mx-1">
                        <p className="fw-bold mb-0">
                          {isAuthor(userId) ? name : sendername}
                        </p>
                        <div
                          className="last-message"
                          style={{ fontSize: "12px" }}
                        >
                          {/* <b>{sendername} : </b> */}
                          {lastMessage?.length > 20
                            ? lastMessage.substring(0, 21) + "..."
                            : lastMessage}
                        </div>
                      </div>
                    </div>
                    <div className="pt-1">
                      <p className="small text-muted mb-1">
                        {chatTimeFormat(updatedAt)}
                      </p>
                      {/* <span className="badge bg-danger rounded-pill float-end">
                      3
                    </span> */}
                    </div>
                  </div>
                </li>
              </Card>
            );
          }
        )
      ) : (
        <div className="text-center">Chats Not Available</div>
      )}
    </>
  );
};

export default UserList;
